  import React from "react";
  import Modal from "react-modal";

  Modal.setAppElement("#root");

  export default function UI_Modal({
    isOpen,
    children,
    closeModal,
    title,
    styleTop,
    styleLeft,
    styleUnit,
  }) {
    let styleModel = {
      content: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundImage:"linear-gradient(90deg,#17253b,#452c7b)",
        height: title==="Forgot Password"? "400px":"270px",
        width: title==="Forgot Password"? "650px":"513px",
        maxWidth: "75%",
        maxHeight: "75%",
        borderRadius: "1rem",
        outline:"none",
        padding: "10px",
        overflow: "auto",
      },
      overlay:{backgroundColor:'var(--midnight-navy-200)'}
    };
    if (styleTop) {
      styleModel.content.top = styleTop + (styleUnit || "%");
    }
    if (styleLeft) {
      styleModel.content.left = styleLeft + (styleUnit || "%");
    }

    return (
      <Modal
        isOpen={isOpen}
        // onRequestClose={closeModal}
        style={styleModel}
        className="user_input_modal drop-shadow-2xl flex justify-center items-center"
      >
        <div className="rounded w-full px-3">
          <div
            className="border-b-[1px] pb-2 border-[#EAD2B0] flex justify-between text-white "
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              // backgroundColor: "--midnight-navy-100",
              
            }}
          >
            <span className="Syne700 text-3xl text-white">{title}</span>
            <span className="yellow-50 text-xl midnight-navy-200 text-center rounded px-2 pt-1" onClick={closeModal} style={{ cursor: "pointer" }}>
            &#10005;
            </span>
          </div>
          <div>{children}</div>
        </div>
      </Modal>
    );
  }
